<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'user.settlement_management' | transloco }}
                </div>
                <div class="card-body" *ngIf="auctions.items.length == 0">
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label">{{ 'user.no_settlement' | transloco }}</label>
                    </div>
                </div>
                <div class="card-body" *ngIf="auctions.items.length > 0">
                    <div class="form-group row">
                        <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'user.event_date' | transloco }}</label>
                        <div class="col-md-3">
                            <wj-combo-box style="width:100%;" #auctionComboBox [itemsSource]="auctions" [displayMemberPath]="'display'" (selectedIndexChanged)="onAuctionChanged()" [isRequired]="true"></wj-combo-box>
                        </div>
                        <div class="col-md-3">
                            <button (click)="downloadPDF()" type="button" class="btn btn-block btn-primary">{{ 'common.download' | transloco }}</button>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div id="viewerContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

